import React from "react";
import { Box, Flex, Text } from "@chakra-ui/react";
import { useNavigate } from "react-router-dom";
import { AppBar, AppIcon, APP } from "../../components/mobileUi";
import {
  DesktopBack,
  DesktopPage,
  DesktopPanel,
  useIsDesktop,
} from "../../components/desktopUi";
import { appImages } from "../../assets/appicons";
import { EMP_BASE_PATH } from "../../config";

const TEXT = "#08142D";

const Card = ({ icon, label, onClick }) => (
  <Flex as="button" type="button" onClick={onClick} flex="1" direction="column" justify="space-between" h="110px" p="16px" borderRadius="12px" bg="white" border="1px solid" borderColor="#E5E9F0" textAlign="left" boxShadow="0px 5px 5px rgba(0,0,0,0.04)">
    <AppIcon src={icon} size={32} color={APP.primary200} />
    <Text fontSize="14px" fontWeight={600} color={TEXT}>{label}</Text>
  </Flex>
);

const CustomerNew = () => {
  const navigate = useNavigate();
  const isDesktop = useIsDesktop();
  const base = `${EMP_BASE_PATH}/tai-chinh/khach-hang`;
  const menuCards = (
    <>
        <Flex gap="12px">
          <Card icon={appImages.icon_customer_personal} label="Khách hàng cá nhân" onClick={() => navigate(`${base}/tao/ca-nhan`)} />
          <Card icon={appImages.icon_customer_business} label="Khách hàng doanh nghiệp" onClick={() => navigate(`${base}/tao/doanh-nghiep`)} />
        </Flex>
    </>
  );

  // ===================== Bản WEB (desktop) =====================
  if (isDesktop) {
    return (
      <DesktopPage title="Thêm khách hàng" right={<DesktopBack onClick={() => navigate(base)} />}>
        <DesktopPanel>
          <Flex gap="16px" flexWrap="wrap" maxW="720px">
            {menuCards}
          </Flex>
        </DesktopPanel>
      </DesktopPage>
    );
  }

  return (
    <Box maxW="480px" mx="auto" bg="white" minH="100dvh">
      <AppBar title="Thêm khách hàng" onBack={() => navigate(base)} />
      <Box px="16px" pt="12px">
        {menuCards}
      </Box>
    </Box>
  );
};

export default CustomerNew;
